import { Action } from '../../../action';
import { DefaultApi } from '../../../api';
import { getCatchError } from '../../../getCatchError';
import { urls } from '../../../urls';

const setGetGamerInformation = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_INFORMATION_GAMER
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetGamerInformationAction({
                    count_gamer: data.data
                }));
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetGamerInformation as SetGetGamerInformation
}